import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Camada_1",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 210 41",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".cls-1{fill:#fff;}.cls-2{fill:#508a7e;}" }) }),
		/* @__PURE__ */ _jsxs("g", { children: [
			/* @__PURE__ */ _jsx("path", {
				className: "cls-1",
				d: "M53.06,33.29V11.26c0-2.54,1.86-4.02,3.94-4.02,1.67,0,3,.61,3.83,2.01l10.08,17.29V7.77h5.23V29.8c0,2.54-1.86,3.98-3.87,3.98-1.63,0-3.03-.57-3.87-1.97l-10.08-17.4v18.88h-5.27Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-1",
				d: "M80.37,23.74c0-5.42,3.94-9.9,9.74-9.9s9.4,4.4,9.4,9.52v1.59h-13.95c.38,2.5,2.31,4.17,5.01,4.17,2.05,0,3.75-.98,4.63-2.73l4.13,2.09c-1.63,3.37-4.74,5.31-8.72,5.31-5.84,0-10.24-4.06-10.24-10.05Zm13.8-1.78c-.23-1.93-1.82-3.41-4.09-3.41s-3.91,1.52-4.28,3.41h8.38Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-1",
				d: "M102.32,23.85c0-5.42,4.44-9.9,10.16-9.9s10.2,4.51,10.2,9.9-4.44,9.93-10.2,9.93-10.16-4.47-10.16-9.93Zm14.98,.04c0-2.65-2.05-4.85-4.82-4.85s-4.78,2.2-4.78,4.85,2.01,4.85,4.78,4.85,4.82-2.2,4.82-4.85Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-1",
				d: "M139.88,10.24h-8.07v23.05h-2.43V10.24h-8.04v-2.27h18.54v2.27Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-1",
				d: "M140.37,33.29v-11.34c0-4.28,2.47-7.32,6.71-7.32,1.14,0,2.24,.23,3.19,.68v2.39c-.91-.53-1.94-.8-3-.8-2.81,0-4.55,2.01-4.55,5.16v11.22h-2.35Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-1",
				d: "M151.62,24.04c0-5.31,3.68-9.59,9.06-9.59s8.83,3.83,8.83,9.06v1.4h-15.58c.38,3.75,3.26,6.52,7.17,6.52,2.5,0,4.78-.95,6.1-3.3l1.82,.98c-1.67,3.03-4.55,4.55-7.92,4.55-5.42,0-9.48-4.13-9.48-9.63Zm15.55-1.03c-.08-3.83-2.77-6.33-6.48-6.33s-6.33,2.77-6.67,6.33h13.16Zm-7.85-11.49l4.32-5.35h2.5l-4.36,5.35h-2.47Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-1",
				d: "M172.98,29.61l1.93-1.06c1.1,2.12,2.81,2.88,5.04,2.88,2.46,0,4.51-1.06,4.51-3.18,0-4.63-10.92-1.4-10.92-8.38,0-3.07,2.81-5.23,6.33-5.23,3,0,5.27,1.29,6.48,3.49l-1.93,1.1c-.99-1.86-2.58-2.39-4.51-2.39-2.05,0-4.02,1.1-4.02,2.99,0,4.48,10.92,1.4,10.92,8.38,0,3.33-3.15,5.42-6.79,5.42-3.11,0-5.69-1.33-7.05-4.02Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-1",
				d: "M190.17,24.04c0-5.27,4.29-9.56,9.67-9.56s9.63,4.32,9.63,9.56-4.21,9.63-9.63,9.63-9.67-4.32-9.67-9.63Zm16.95,.04c0-4.02-3.22-7.36-7.28-7.36s-7.32,3.34-7.32,7.36,3.22,7.36,7.32,7.36,7.28-3.34,7.28-7.36Z"
			})
		] }),
		/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M35.87,0H5.12C3,0,1.18,1.29,.4,3.13c-.26,.61-.4,1.29-.4,2H0v30.75H0v5.12H35.87c2.12,0,3.94-1.29,4.72-3.13,.26-.61,.4-1.29,.4-1.99h0V5.13h0V0h-5.13Z"
		}), /* @__PURE__ */ _jsxs("g", { children: [
			/* @__PURE__ */ _jsx("polygon", {
				className: "cls-2",
				points: "20.5 8.18 8.2 15.38 8.2 16.4 32.8 16.4 32.8 15.38 20.5 8.18"
			}),
			/* @__PURE__ */ _jsx("polygon", {
				className: "cls-2",
				points: "31.77 28.68 9.22 28.68 9.22 30.73 8.2 30.73 8.2 32.78 32.8 32.78 32.8 30.73 31.77 30.73 31.77 28.68"
			}),
			/* @__PURE__ */ _jsx("polygon", {
				className: "cls-2",
				points: "10.25 25.61 10.25 27.66 16.4 27.66 16.4 25.61 14.86 25.61 14.86 19.46 16.4 19.46 16.4 17.41 10.25 17.41 10.25 19.46 11.79 19.46 11.79 25.61 10.25 25.61"
			}),
			/* @__PURE__ */ _jsx("polygon", {
				className: "cls-2",
				points: "24.6 25.61 24.6 27.66 30.75 27.66 30.75 25.61 29.21 25.61 29.21 19.46 30.75 19.46 30.75 17.41 24.6 17.41 24.6 19.46 26.14 19.46 26.14 25.61 24.6 25.61"
			}),
			/* @__PURE__ */ _jsx("polygon", {
				className: "cls-2",
				points: "17.43 25.61 17.43 27.66 23.57 27.66 23.57 25.61 22.04 25.61 22.04 19.46 23.57 19.46 23.57 17.41 17.43 17.41 17.43 19.46 18.96 19.46 18.96 25.61 17.43 25.61"
			})
		] })] })
	]
});
export default SvgLogo;
